import { CreditCard, Delete, Done, Edit, Print } from "@mui/icons-material";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import CustomPagination from "../../../../../components/custom-pagination/CustomPagination";
import { AppMisc } from "../../../../../misc/appMisc";
import { AppUtils } from "../../../../../utils/appUtils";
import { CASTE_CODES, FEMALE, MALE, MUL_DARTA_SEWA_TYPES, NO_RECORDS_FOUND } from "../../../../../utils/constants";
import { NEW_PATIENT, OTHER, PREVIOUS_PATIENT } from "../../../../../utils/constants/forms";


const MulDartaaRegister = ({ page, totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    if (props.tableData !== null) {
      setMainRegisterData(props.tableData);
    }
  }, [props.tableData]);


  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Box display={"flex"} justifyContent={"flex-end"}>
            <IconButton>
              <Print />
            </IconButton>
          </Box>
        )}
        content={() => tableRef.current}
      />
      <TableContainer classes={{ root: "fixed-head-table-container" }} ref={tableRef}>
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Mul Dartaa Register">
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell rowSpan={2}>क्र.सं.</TableCell>
              <TableCell rowSpan={2}>दर्ता मिति</TableCell>
              <TableCell colSpan={2}>दर्ता नम्बर</TableCell>
              <TableCell colSpan={2}>सेवाग्राहीको</TableCell>
              <Tooltip title=
                {
                  <>
                    {CASTE_CODES.map(caste => (
                      <Typography key={caste.value} variant="caption"> {caste.label} </Typography>
                    ))}
                  </>
                }
                placement="top"
                arrow
              >
                <TableCell rowSpan={2}>जाती कोड</TableCell>
              </Tooltip>
              <TableCell colSpan={3}>उमेर</TableCell>
              <TableCell colSpan={5}>ठेगाना</TableCell>
              <TableCell rowSpan={2}>राष्ट्रिय परिचयपत्र नम्वर</TableCell>
              <TableCell rowSpan={2}>सम्पर्क नम्बर</TableCell>
              <Tooltip title=
                {
                  <>
                    {MUL_DARTA_SEWA_TYPES.map(sewaType => (
                      <Typography key={sewaType.value} variant="caption"> {sewaType.label} </Typography>
                    ))}
                  </>
                }
                placement="top"
                arrow
              >
                <TableCell rowSpan={2}>सेवाको किसिम</TableCell>
              </Tooltip>
              <TableCell rowSpan={2}>नि:शुल्क/शुल्क रु.</TableCell>
              <TableCell rowSpan={2}>प्रेषण भई आएको संस्थाको नाम</TableCell>
              <TableCell rowSpan={2} className="print-none">सम्पादन</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>पहिलो पटक</TableCell>
              <TableCell>पुनरावृत</TableCell>
              <TableCell>नाम</TableCell>
              <TableCell>थर</TableCell>
              <TableCell>महिला</TableCell>
              <TableCell>पुरुष</TableCell>
              <TableCell>अन्य</TableCell>
              <TableCell>जिल्ला</TableCell>
              <TableCell>नगर/गाउँपालिका</TableCell>
              <TableCell>वडा नं.</TableCell>
              <TableCell>टोल</TableCell>
              <TableCell>अन्य मुलुक</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            {
              mainRegisterData.length > 0 ? (
                mainRegisterData?.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                    <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.dartaaMiti)}</TableCell>
                    <TableCell>{row?.patientType === NEW_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row?.mulDartaaNumber) : "-"}</TableCell>
                    <TableCell>{row?.patientType === PREVIOUS_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row.mulDartaaNumber) : "-"}</TableCell>
                    <TableCell>{row?.patientFirstName && row?.patientFirstName}</TableCell>
                    <TableCell>{row?.patientLastName && row?.patientLastName}</TableCell>
                    <TableCell>{row.casteCode && AppUtils.replaceWithNepaliDigit(row.casteCode) || "-"}</TableCell>
                    <TableCell>{row?.gender === FEMALE ? AppUtils.replaceWithNepaliDigit(row.age) + " " + AppMisc.getAgeUnitLabel(row.ageUnit) : "-"}</TableCell>
                    <TableCell>{row?.gender === MALE ? AppUtils.replaceWithNepaliDigit(row.age) + " " + AppMisc.getAgeUnitLabel(row.ageUnit) : "-"}</TableCell>
                    <TableCell>{row?.gender === OTHER ? AppUtils.replaceWithNepaliDigit(row.age) + " " + AppMisc.getAgeUnitLabel(row.ageUnit) : "-"}</TableCell>
                    <TableCell>{row?.district && AppMisc.getDistrictName(row?.district)}</TableCell>
                    <TableCell>{row?.palikaName && AppMisc.getMunicipalityName(row?.palikaName)}</TableCell>
                    <TableCell>{row?.wardNumber && AppUtils.replaceWithNepaliDigit(row?.wardNumber)}</TableCell>
                    <TableCell>{row?.gaunOrTole || "-"}</TableCell>
                    <TableCell>{row?.otherCountry ? <Done /> : "-"}</TableCell>
                    <TableCell>{row?.nid || "-"}</TableCell>
                    <TableCell>{row?.phoneNumber && AppUtils.replaceWithNepaliDigit(row?.phoneNumber)}</TableCell>
                    <TableCell>{row?.sewaType && AppUtils.replaceWithNepaliDigit(row?.sewaType?.join(", "))}</TableCell>
                    <TableCell>{row.cost || "-"}</TableCell>
                    <TableCell>{row.referredIn || "-"}</TableCell>
                    <TableCell className="print-none">
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <IconButton aria-label="edit" onClick={() => props.onEditRow(row.id)}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <Tooltip title="स्वास्थ्य सेवा कार्ड हेर्न यहा क्लिक गर्नुहोस" placement="top" arrow>
                          <a target="_blank" rel="noreferrer" href={`health-service-card?id=${row.id}&fromMulDartaaRegister=true`}>
                            <CreditCard fontSize="small" />
                          </a>
                        </Tooltip>
                        <Tooltip title="मूल दर्ता रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                          <IconButton onClick={() => props.deleteRow(row.id)}>
                            <Delete fontSize="small" color='secondary' />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))) : (
                <TableRow>
                  <TableCell colSpan="22" size="medium">{NO_RECORDS_FOUND}</TableCell>
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        count={totalSize}
      />
    </>
  )
}

export default MulDartaaRegister